import { colors } from "@ui/style/colors";

export type TabVariant = "all" | "default";

export const getTabBackground = (active?: boolean): string => {
	if (!active) return "transparent";
	return colors.primary;
};

export const getTabColor = (active?: boolean, variant?: TabVariant): string => {
	if (!active) return colors.black;
	return variant === "all" ? colors.white : colors.black;
};

